import './ThemeSixSlides.css';

import Carousel from 'react-multi-carousel';
import CommonService from '../../../../services/commonService';
import React from 'react';

const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 5,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 4,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

const ThemeSixSlider = props => {
  const operator = CommonService.getLocal('op');

  return (
    <div className="themes-theme-five-slider">
      <style>
        .themes-theme-five-slider .react-multi-carousel-dot--active button {'{'}
        background:
        {operator && operator.color_codes && operator.color_codes.primary_color
          ? operator.color_codes.primary_color
          : '#018137'}
        ;{'}'}
        .react-multiple-carousel__arrow {'{'}
        background-color: transparent;
        {'}'}
        .react-multiple-carousel__arrow:before {'{'}
        color: #db7838; align-items: center; color: #db7838; display: flex; justify-content: center;
        border-radius: 100%; font-size: 55px
        {'}'}
        .react-multiple-carousel__arrow:hover {'{'}
        background-color: transparent;
        {'}'}
        .react-multiple-carousel__arrow--right{'{'}
        right: 3px;
        {'}'}
        .react-multiple-carousel__arrow--left {'{'}
        left: 3px;
        {'}'}
        .react-multi-carousel-item {'{'}
        padding: 0 45px !important;
        {'}'}
        .react-multiple-carousel__arrow:before {'{'}
        display: none !important;
        {'}'}
        button.react-multiple-carousel__arrow.react-multiple-carousel__arrow--left
        {'{'}
        background-image:url(/assets/pullmanSanAndres/leftorangearrow.svg) !important;
        background-repeat: no-repeat;
        {'}'}
        button.react-multiple-carousel__arrow.react-multiple-carousel__arrow--right
        {'{'}
        background-image:url(/assets/pullmanSanAndres/rightorangearrow.svg) !important;
        background-repeat: no-repeat; background-position-x: right;
        {'}'}
      </style>
      <Carousel
        responsive={responsive}
        swipeable={true}
        draggable={false}
        arrows={true}
        infinite={true}
        autoPlay={true}
        autoPlaySpeed={3000}
        customTransition="all .5"
        transitionDuration={2000}
        // removeArrowOnDeviceType={['desktop', 'tablet', 'mobile']}
      >
        {props.slides &&
          (props.slides.length || []) > 0 &&
          props.slides.map((slide, index) => {
            return <SlideItem slide={slide} index={index} />;
          })}
      </Carousel>
    </div>
  );
};

const SlideItem = props => {
  return (
    <div className="slide-item" key={props.index}>
      <div className="image-container">
        <img className="image" src={props.slide.banner} alt="slide-item" />
        {props.slide.text && <p>{props.slide.text}</p>}
      </div>
    </div>
  );
};

export default ThemeSixSlider;



// WEBPACK FOOTER //
// ./src/features/themes/theme6/components/ThemeSixSlides.js